import { Textarea, TextInput } from "../../common";

type NodeSettingEntry = {
    id?: string | null;
    tempId: string;
    neuronTemplateId: string;
    nodeSettingType: string;
    nodeSettingsName: string;
    explanation: string;
    description: string;
    boundedDataJson: string;
    nodeNeuronSettingsJson: string;
    dataClassificationId: string;
  };
  
interface NodeSettingsFormProps {
  kind: string;
  index: number;
  entry: any;
  handleNodeSettingsChange: (
    kind: string,
    index: number,
    field: keyof NodeSettingEntry,
    value: string
  ) => void;
}

const NodeSettingsForm = (props: NodeSettingsFormProps) => {
  const { kind, index, entry, handleNodeSettingsChange } = props;
  return (
    <tr className="node-ratecoding-table__editor">
      <td colSpan={7}>
        <div className="node-ratecoding-card">
          <div className="synapse-entity-modal__fieldset node-ratecoding-card__grid">
            <TextInput
              id={`${kind}-nodesetting-${index}-name`}
              name="nodeSettingsName"
              type="text"
              value={entry.nodeSettingsName}
              onChange={(event) =>
                handleNodeSettingsChange(
                  kind,
                  index,
                  "nodeSettingsName",
                  event.target.value
                )
              }
              placeholder="Primary plan"
              variant="modal"
              label="Setting name"
            />
            <TextInput
              id={`${kind}-nodesetting-${index}-type`}
              name="nodeSettingType"
              type="text"
              value={entry.nodeSettingType}
              onChange={(event) =>
                handleNodeSettingsChange(
                  kind,
                  index,
                  "nodeSettingType",
                  event.target.value
                )
              }
              placeholder="threshold, safety, …"
              variant="modal"
              label="Setting type"
            />
          </div>
          <div className="synapse-entity-modal__fieldset node-ratecoding-card__grid">
            <TextInput
              id={`${kind}-nodesetting-${index}-template`}
              name="neuronTemplateId"
              type="text"
              value={entry.neuronTemplateId}
              onChange={(event) =>
                handleNodeSettingsChange(
                  kind,
                  index,
                  "neuronTemplateId",
                  event.target.value
                )
              }
              placeholder="Node template UUID"
              variant="modal"
              label="Node template ID"
            />
            <TextInput
              id={`${kind}-nodesetting-${index}-dataclass`}
              name="dataClassificationId"
              type="text"
              value={entry.dataClassificationId}
              onChange={(event) =>
                handleNodeSettingsChange(
                  kind,
                  index,
                  "dataClassificationId",
                  event.target.value
                )
              }
              placeholder="Data classification UUID"
              variant="modal"
              label="Data classification ID"
            />
          </div>
          <div className="synapse-entity-modal__form-group">
            <Textarea
              id={`${kind}-nodesetting-${index}-explanation`}
              name="explanation"
              rows={3}
              value={entry.explanation}
              onChange={(event) =>
                handleNodeSettingsChange(
                  kind,
                  index,
                  "explanation",
                  event.target.value
                )
              }
              placeholder="Explain how this configuration should be used"
              variant="modal"
              label="Explanation"
            />
          </div>
          <div className="synapse-entity-modal__form-group">
            <Textarea
              id={`${kind}-nodesetting-${index}-description`}
              name="description"
              rows={3}
              value={entry.description}
              onChange={(event) =>
                handleNodeSettingsChange(
                  kind,
                  index,
                  "description",
                  event.target.value
                )
              }
              placeholder="Describe when this applies"
              variant="modal"
              label="Description"
            />
          </div>
          <div className="synapse-entity-modal__form-group">
            <Textarea
              id={`${kind}-nodesetting-${index}-boundedData`}
              name="boundedDataJson"
              rows={4}
              value={entry.boundedDataJson}
              onChange={(event) =>
                handleNodeSettingsChange(
                  kind,
                  index,
                  "boundedDataJson",
                  event.target.value
                )
              }
              placeholder='{"bounds": {"min": 0, "max": 1}}'
              variant="modal"
              label="Bounded data (JSON)"
              hint="Optional JSON describing allowed ranges or constraints."
            />
          </div>
          <div className="synapse-entity-modal__form-group">
            <Textarea
              id={`${kind}-nodesetting-${index}-nodeNeuronSettings`}
              name="nodeNeuronSettingsJson"
              rows={4}
              value={entry.nodeNeuronSettingsJson}
              onChange={(event) =>
                handleNodeSettingsChange(
                  kind,
                  index,
                  "nodeNeuronSettingsJson",
                  event.target.value
                )
              }
              placeholder='{"nodes": [{"id": "n1"}]}'
              variant="modal"
              label="Node processing settings (JSON)"
              hint="Optional JSON payload stored alongside this setting."
            />
          </div>
        </div>
      </td>
    </tr>
  );
};

export default NodeSettingsForm;
